import { FC, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { AiOutlineFilter } from "react-icons/ai";

import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { getDDMMYYYFormat, isDateInRange } from "../../../../helper/dateTimeHelper";

import { approverType } from "../../../../constants";

import { Box, Icon, UserManual, Table } from "../../../../components";
import moment, { Moment } from "moment";
import { getStatusBaseOnApprover, getStepBaseOnApprover } from "./utils";
import { requestStatusTypes } from "../types";
import { ExportFileExcel } from "../components";
import { compareRequestStatus, getRequestStatusHasAssigneeOptions } from "../../utils";
import { useDeleteAccountRequests } from "./hooks";
import CreateRequestButton from "../../components/CreateRequestButton";
import { useDeleteAccountColumns } from "./hooks/use-delete-account-columns";
import { useUser } from "../../../../hook";

export const procedureDeleteUserAccount: FC = withProcedureWraper(() => {
  const history = useHistory();
  const { email } = useUser();
  const { columns } = useDeleteAccountColumns();
  const {
    mappedDeleteAccountMyRequests,
    mappedDeleteAccountRequests2 = [],
    isLoading,
    guideLink,
  } = useDeleteAccountRequests();

  const [filters, setFilters] = useState<any>({
    createdDateTime: null,
    eRequestStatus: null,
  });

  const filteredDataSource = useMemo(() => {
    let dataSource = [...mappedDeleteAccountRequests2];
    if (filters.eRequestStatus) {
      dataSource = dataSource.filter((e: any) => compareRequestStatus(e.eRequestStatus, filters?.eRequestStatus!));
    }
    if (filters.createdDateTime) {
      const [startDate, endDate]: [Moment, Moment] = filters.createdDateTime;
      dataSource = dataSource.filter((e: any) => {
        const createDate = moment(e.createdDateTime);
        return isDateInRange(createDate, startDate.startOf("day"), endDate.endOf("day"));
      });
    }

    return dataSource;
  }, [filters, mappedDeleteAccountRequests2]);

  const requestStatusOptions = getRequestStatusHasAssigneeOptions("Đã Xoá");

  const flattedData = mappedDeleteAccountRequests2.map((record: any) => {
    const status = getStatusBaseOnApprover(record, email);
    const step = getStepBaseOnApprover(record, email);

    const requestStatus =
      status === requestStatusTypes.submitted && step === approverType.assignee
        ? requestStatusTypes.submittedAssignee
        : record.eRequestStatus;

    return {
      id: record.id,
      createdDateTime: getDDMMYYYFormat(record.createdDateTime),
      eRequestStatus: record.eRequestStatus,
      eRequestPersonName: record.createdByName,
      ePhoneNumber: record.ePhoneNumber,
      eDepartment: record.eDepartment,
      eUnit: record.eUnit,
      eDescription: record.eDescription,
      eRequestStatusText: requestStatusOptions.find((e) => e.value === requestStatus)?.label,
    };
  });

  return (
    <div className="ITCodeGrantedPage">
      <div className="pd15">
        <UserManual title="XÓA TÀI KHOẢN" icon={<Icon.DeleteBin5Line />} guideLink={guideLink} />
        <Box
          title="Yêu cầu của tôi"
          titleRight={
            <CreateRequestButton
              onClick={() => history.push(Routes.createDeleteUserAccount.path.replace(":id", "0"))}
            />
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            scroll={{ x: 1100 }}
            dataSource={mappedDeleteAccountMyRequests}
            onRow={(record) => ({
              onClick: () => history.push(Routes.deleteUserAccountDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>

        <Box
          title="Các yêu cầu cần duyệt"
          titleRight={
            <ExportFileExcel
              exportContent={{
                fileName: "Danh sach can duyet yeu cau xoa tai khoan",
                content: [
                  { header: "Mã yêu cầu", dataIndex: "id" },
                  { header: "Người yêu cầu", dataIndex: "eRequestPersonName" },
                  { header: "Cơ quan/Đơn vị", dataIndex: "eDepartment" },
                  { header: "SĐT Người yêu cầu", dataIndex: "ePhoneNumber" },
                  { header: "Đơn vị", dataIndex: "eUnit" },
                  { header: "Mô tả", dataIndex: "eDescription" },
                  { header: "Trạng thái", dataIndex: "eRequestStatusText" },
                ],
              }}
              data={flattedData}
              requestStatusOptions={requestStatusOptions}
              onChange={(_, allValues: any) => {
                setFilters(allValues);
              }}
            >
              <div>
                <CreateRequestButton label="Bộ lọc" prefixIcon={<AiOutlineFilter />} />
              </div>
            </ExportFileExcel>
          }
        >
          <Table
            loading={isLoading}
            rowKey="id"
            columns={columns}
            scroll={{ x: 1100 }}
            dataSource={filteredDataSource}
            onRow={(record) => ({
              onClick: () => history.push(Routes.deleteUserAccountDetailPage.path.replace(":id", record.id)),
              style: { cursor: "pointer" },
            })}
          />
        </Box>
      </div>
    </div>
  );
});
